import { render } from "./PaasCoordsDiff.vue?vue&type=template&id=1d1b2bd4&scoped=true"
import script from "./PaasCoordsDiff.vue?vue&type=script&lang=js"
export * from "./PaasCoordsDiff.vue?vue&type=script&lang=js"

import "./PaasCoordsDiff.vue?vue&type=style&index=0&id=1d1b2bd4&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1b2bd4"]])

export default __exports__